import DashboardService from "@/services/DashboardService";
//import PatreonService from "@/services/PatreonService";

const user = JSON.parse(localStorage.getItem("login"));
const initialState = user ? { user } : { user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return DashboardService.getLogin(user).then(
        () => {
          return commit("loginSuccess");
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    //logout({ commit }) {
    //  DashboardService.logout();
    //  commit('logout');
    //},
  },
  mutations: {
    loginSuccess(state) {
      state.user = JSON.parse(localStorage.getItem("login"));
    },
    updateMember(state, payload) {
      state.user.member = payload;
    },
    loginFailure(state) {
      state.user = null;
    },
    logout(state) {
      state.user = null;
    },
    // registerSuccess(state) {
    //   state.status.loggedIn = false;
    // },
    // registerFailure(state) {
    //   state.status.loggedIn = false;
    // },
  },
};
